module.exports = __webpack_public_path__ + "img/hr-tree-07-e-leaves.0819a5f3.png";